import { SectionTabsLayout, type SectionTabItem } from "./section-tabs-layout";

const DISCOVERY_TABS: SectionTabItem[] = [
  {
    label: "Search Overrides",
    to: "/search/editorial-overrides",
    match: (pathname) => pathname.startsWith("/search/editorial-overrides"),
  },
  {
    label: "Taxonomy",
    to: "/taxonomy",
    match: (pathname) => pathname.startsWith("/taxonomy"),
  },
  {
    label: "Machine Tags",
    to: "/machine-tags",
    match: (pathname) => pathname.startsWith("/machine-tags"),
  },
  {
    label: "Entity Assets",
    to: "/entities/assets",
    match: (pathname) => pathname.startsWith("/entities"),
  },
];

export function DiscoveryLayout() {
  return <SectionTabsLayout id="discovery" items={DISCOVERY_TABS} />;
}
